<template>
    <div class="Postcode">
        <!-- s: header -->
        <header id="header-slidePanel">
            <h2>우편번호</h2>
            <div class="btn_back">
                <a @click="slidePanelClose"><img src="@/assets/images/btn_close.png" width="50" alt="이전" /></a>
            </div>
        </header>
        <!-- e: header -->
        <!-- 우편번호 -->
        <div class="contents-area-slidePanel">
            <vue-daum-postcode @complete="getPostCode($event)"/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Postcode',
    data() {
        return {
        }
    },
    // 감시자
    watch: {
    },
    // $el 생성전
    created(){
    },
    // $el 생성후
    mounted() {
        window.callbackBackKey = this.callbackBackKey;
    },
    methods: {
        // APP 뒤로가기
        callbackBackKey(){
            this.slidePanelClose();
        },
        // 우편번호 입력
        getPostCode(e){
            let param = {};
            param.result = 'close';
            param.zipcode = e.zonecode;
            param.address = e.address;

            this.slidePanelClose(param);
        }
    }
}
</script>

<style scoped>
</style>
